"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Failure = {
    NETWORK: 'Network error',
    MOVE_FORBIDDEN: 'You are not allowed to play this move',
    UNDO_FORBIDDEN: 'This move cannot be undone',
    TUTORIAL_MOVE_EXPECTED: 'You must play the move expected by the tutorial'
};
exports.default = Failure;
